// Brand images live in the database (Admin Center → Branding, docs/adr/0019), never in the repository:
// these are the public URLs the backend serves them from. Show them with <BrandImage>, which falls back
// when an image hasn't been uploaded.
const BRANDING = "/api/branding";

/** Brand image URLs. Use as-is, never redraw or recolor. */
export const assets = {
  logo: `${BRANDING}/logo`,
  logoDark: `${BRANDING}/logo-dark`,
  iconLight: `${BRANDING}/icon`,
  iconDark: `${BRANDING}/icon-dark`,
  iconAccent: `${BRANDING}/icon-accent`,
  monogram: `${BRANDING}/icon`,
};
